import { InteriorComponent } from '@inter-ikea-storageone/range';
import { HierarchyUtils, Entity } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeAllInteriorsFromSelectedFrame = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) {
    return null;
  } else {
    const interiorsProducts = HierarchyUtils.children(selectedEntity).filter((child: Entity) =>
      child.hasComponent(InteriorComponent.id)
    );

    if (interiorsProducts) {
      removeProducts(interiorsProducts, coreApi, products);
    }
  }
};

export default removeAllInteriorsFromSelectedFrame;
